import { useEffect } from 'react';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { get } from '../../../api/fetch';
import { claimsWithUnreadDocumentsStorageKey, getSessionStorageJSON } from '../utils/utils';
import { useIsLoggedIn } from './useIsLoggedIn';
import { useUserEligibility } from './useUserEligibility';
import { Count } from '../types/Count';

export const useClaimsWithUnreadDocumentsCount = (): UseQueryResult<number> => {
  const { data: isLoggedIn } = useIsLoggedIn();
  const { data: eligibility } = useUserEligibility();

  const sessionValue = getSessionStorageJSON<Count>(claimsWithUnreadDocumentsStorageKey)?.count;

  const enabled = !!isLoggedIn && (eligibility?.f2100Eligible || eligibility?.iditEligible);

  const query = useQuery({
    queryKey: [claimsWithUnreadDocumentsStorageKey],
    queryFn: async () => {
      const response = await get<Count>('/api-mysite-private/api-mysite/api/v1/documents/unread/count');

      if (response?.count !== undefined) {
        sessionStorage.setItem(claimsWithUnreadDocumentsStorageKey, JSON.stringify(response));
      }

      return response?.count;
    },
    select: (result: number) => result ?? 0,
    enabled,
    initialData: sessionValue ?? 0
  });

  useEffect(() => {
    const handleChange = () => query.refetch();

    window.addEventListener(claimsWithUnreadDocumentsStorageKey, handleChange);

    return () => window.removeEventListener(claimsWithUnreadDocumentsStorageKey, handleChange);
  }, [query]);

  return query;
};
